export const professionList = {
  professionMarketing: 'Coordinador de marketing',
  professionWebDesigner: 'Diseñador web',
  professionSales: 'Presidente de ventas',
  professionCoordinator: 'Coordinador de marketing',
};

export const pageTitle = 'Nuestro equipo';
